import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  BalanceCard,
  BalanceContainer,
  BalanceTopCard,
  BalanceTopCardButton,
} from "./Balance.styled";
import { useDispatch, useSelector } from "react-redux";
import { getUserBalance } from "../../feature/wallet/WalletActions";
import { inviteErnings } from "../../feature/invite/InviteActions";
import { minerEarnings } from "../../feature/minerEarning/MinerEarningActions";
import { createDeposit } from "../../feature/deposit/DepositActions";
import ReactLoading from "react-loading";

const Balance = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { balance } = useSelector((state) => state.wallet);
  const { user } = useSelector((state) => state.user);
  const { loading } = useSelector((state) => state.deposit);
  const { earning } = useSelector((state) => state.invite);
  const { minerEarning } = useSelector((state) => state.minerEarning);
  const stakingEarning = 0.0;

  useEffect(() => {
    Object.keys(user).length && dispatch(getUserBalance({ user: user }));
    Object.keys(user).length && dispatch(inviteErnings({ user: user.id }));
    Object.keys(user).length && dispatch(minerEarnings({ user: user.id }));
  }, [dispatch, user]);

  return (
    <BalanceContainer>
      <BalanceTopCard>
        <BalanceTopCardButton
          disabled={loading}
          onClick={() => {
            if (localStorage.getItem("endTime")) {
              navigate(`/deposit/${localStorage.getItem("depositId")}`);
            } else {
              dispatch(createDeposit({ user: user.id }))
                .unwrap()
                .then((res) => {
                  navigate(`/deposit/${res.data.id}`);
                  localStorage.setItem("depositId", res.data.id);
                })
                .catch((res) => console.log(res));
            }
          }}
        >
          {loading ? (
            <ReactLoading
              type={"spinningBubbles"}
              height={"20px"}
              width={"20px"}
            />
          ) : (
            "Deposit"
          )}
        </BalanceTopCardButton>
        <BalanceTopCardButton onClick={() => navigate("/withdrawal")}>
          Withdrawal
        </BalanceTopCardButton>
        <BalanceTopCardButton onClick={() => navigate("/history")}>
          History
        </BalanceTopCardButton>
      </BalanceTopCard>
      <BalanceCard>
        <div style={{ marginBlockEnd: "20px" }}>My Balance (TRX)</div>
        <h2 style={{ fontWeight: "bolder" }}>{balance}</h2>
      </BalanceCard>
      <BalanceCard>
        <div style={{ marginBlockEnd: "30px" }}>
          <div style={{ marginBlockEnd: "10px" }}>Miner Earnings (TRX)</div>
          <span style={{ fontWeight: "bolder" }}>
            {minerEarning && minerEarning.amount_earned}
          </span>
        </div>
        <div style={{ marginBlockEnd: "30px" }}>
          <div style={{ marginBlockEnd: "10px" }}>Invite Earnings (TRX)</div>
          <span style={{ fontWeight: "bolder" }}>
            {earning && earning.amount_earned}
          </span>
        </div>
        <div style={{ marginBlockEnd: "30px" }}>
          <div style={{ marginBlockEnd: "10px" }}>Stake Earnings (TRX)</div>
          <span style={{ fontWeight: "bolder" }}>{stakingEarning}</span>
        </div>
        <div>
          <div>Total Earned (TRX)</div>
          <span style={{ fontWeight: "bolder" }}>
            {(
              minerEarning &&
              earning &&
              parseFloat(minerEarning.amount_earned) +
                parseFloat(earning.amount_earned) +
                parseFloat(stakingEarning)
            ).toFixed(2)}
          </span>
        </div>
      </BalanceCard>
    </BalanceContainer>
  );
};

export default Balance;
